function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { injectTestId } from "@cvent/nucleus-test-automation";
var extendId = function(id, extension) {
    return "".concat(id).concat(extension ? "-".concat(extension) : '');
};
export function resolveIds(id, testIdProp, extension) {
    var noInject = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var testID = testIdProp || id;
    var injectedID = noInject ? {
        testID: extendId(testID, extension)
    } : injectTestId(extendId(testID, extension));
    return _objectSpread({}, id && {
        id: extendId(id, extension)
    }, testID && injectedID);
}
export default resolveIds;
